import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import categoryIconsMap from "assets/icons/categoryIcons/categoryIcons";
import React, { FC } from "react";

export interface IDynamicIcon {
  name: string;
  size?: number;
  color?: string;
}

const DynamicIcon: FC<IDynamicIcon> = ({ name, size = 40, color = "#333" }) => {
  const { resolution } = useScreenStore();
  const IconComponent = categoryIconsMap[name];

  if (!IconComponent) {
    return <></>;
  }

  return (
    <IconComponent
      style={{ minWidth: resolution === ResolutionType.FULL_HD ? 60 : 40 }}
      width={size}
      height={size}
      fill={color}
    />
  );
};

export default DynamicIcon;
